import axios from 'axios';

import { Feedback } from 'admin/inbox-config/InboxConfig.types';

export const submitFeedback = async (tenantId: number, feedback: Feedback): Promise<string> => {
    const {
        data: { jiraIssueKey },
    } = await axios.post(`/api/tenants/${tenantId}/inbox-config/feedback`, {
        feedback,
    });

    return jiraIssueKey;
};
